module.exports = __webpack_public_path__ + "static/img/bg.2d2e4ed0.jpg";